module.exports = __webpack_public_path__ + "../resources/images/illustration_junk-fe44737bf241f94f0bd03428d40f705c.svg";